/**
 * PrivacyPolicyHero — Weidner Via6 page hero for /privacy-policy.
 * See `FloorPlansHero.tsx` and `_PageImageHeroBody.tsx` for the shared
 * pattern. Owns its slot registration, contentSchema, and hidden
 * literal-path anchors; visual rendering is delegated to the body.
 */

import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { RichTextContent, EditableSlotGroup } from '@vibesites/runtime/react';
import { PageImageHeroBody } from './_PageImageHeroBody';

const bgDef = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Privacy policy hero image',
    },
  },
  sourceBinding: {
    collection: 'photo_gallery',
    defaultIndex: 0,
    fieldMappings: { image: 'image', alt: 'alt_text' },
  },
};

export function PrivacyPolicyHero() {
  return (
    <>
      <PageImageHeroBody
        titlePath="privacypolicyhero.title"
        bgPath="privacypolicyhero.bg_image"
        bgDef={bgDef}
        defaultTitle="Privacy Policy"
        keywords={[]}
        pageHint="privacypolicyhero"
        altText="Privacy policy hero image"
      />

      <RichTextContent
        path="privacypolicyhero.title"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      />
      <EditableSlotGroup
        groupPath="privacypolicyhero.bg_image"
        definition={bgDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PrivacyPolicyHero',
  displayName: 'Privacy Policy Hero',
  tokens: {
    'privacypolicyhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: 'Privacy Policy',
    },
  },
  slotGroups: {
    'privacypolicyhero.bg_image': {
      label: 'Background Image',
      fields: {
        image: {
          label: 'Image',
          type: 'image',
          defaultField: 'property_featured_image',
        },
        alt: {
          label: 'Alt Text',
          type: 'text',
          defaultValue: 'Privacy policy hero image',
        },
      },
      sourceBinding: {
        collection: 'photo_gallery',
        defaultIndex: 0,
        fieldMappings: { image: 'image', alt: 'alt_text' },
      },
    },
  },
};

(PrivacyPolicyHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PrivacyPolicyHero;
